import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  body,
  confirmText = "Confirm",
  confirmVariant = "danger",
  cancelText = "Cancel",
  confirmDisabled = false,
}) => {
  return (
    <Modal show={show} onHide={onHide} centered className="archon-branded-modal">
      <Modal.Header closeButton className="archon-branded-modal__header">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {body}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {cancelText}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm} disabled={confirmDisabled}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;